import { render } from "./Approve.vue?vue&type=template&id=650d87f2"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"

import "./Approve.vue?vue&type=style&index=0&id=650d87f2&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__